export const getInstallmentOptionName = (option) => {
    if (option === 'full') {
        return 'полная стоимость';
    }
    if (option === 'without') {
        return 'без взноса';
    }
    return option;
}
